export const initialsOf = (displayName: string): string => {
    const trimmed = displayName.trim();
    if (!trimmed) {
        return '?';
    }
    if (trimmed.includes('@')) {
        const local = trimmed.split('@', 1)[0];
        const cleaned = local.replaceAll(/[._-]+/g, ' ').trim();
        return takeInitials(cleaned);
    }
    return takeInitials(trimmed);
};

const takeInitials = (source: string): string => {
    const parts = source.split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
        return '?';
    }
    if (parts.length === 1) {
        return parts[0][0]?.toUpperCase() ?? '?';
    }
    const first = parts.at(0)?.[0] ?? '';
    const last = parts.at(-1)?.[0] ?? '';
    return (first + last).toUpperCase();
};

export const firstNameOf = (displayName: string): string => {
    const trimmed = displayName.trim();
    if (!trimmed) {
        return '';
    }
    if (trimmed.includes('@')) {
        const local = trimmed.split('@', 1)[0];
        const head = local.split(/[._-]+/).filter(Boolean)[0] ?? local;
        return head.charAt(0).toUpperCase() + head.slice(1);
    }
    return trimmed.split(/\s+/)[0] ?? trimmed;
};

// ADO and the roster differ in casing.
export const sameEmail = (a: string, b: string): boolean => a.toLowerCase() === b.toLowerCase();
